import { render, staticRenderFns } from "./pwa_texts.vue?vue&type=template&id=44e1dc55&scoped=true&"
import script from "./pwa_texts.vue?vue&type=script&lang=js&"
export * from "./pwa_texts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e1dc55",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44e1dc55')) {
      api.createRecord('44e1dc55', component.options)
    } else {
      api.reload('44e1dc55', component.options)
    }
    module.hot.accept("./pwa_texts.vue?vue&type=template&id=44e1dc55&scoped=true&", function () {
      api.rerender('44e1dc55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/settings/tabs/pwa_texts.vue"
export default component.exports